@import (reference) '../../../../../../constants/spacing.module.less';

.returnsTabExpandedSection {
  border-top: 1px dashed var(--gray-DFE4E8);
  display: flex;
  justify-content: flex-end;
  padding-top: @space-24;
}
